export const formatDuration = (durationMs: number): string => {
  if (durationMs <= 0) return '0s';
  const totalSeconds = Math.floor(durationMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes === 0) return `${seconds}s`;
  if (seconds === 0) return `${minutes}m`;
  return `${minutes}m ${seconds}s`;
};

const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_DAY = 86_400;

export const formatLongDuration = (durationMs: number): string => {
  const totalSeconds = Math.floor(durationMs / 1000);
  if (totalSeconds < SECONDS_PER_MINUTE) return `${Math.max(totalSeconds, 0)}s`;
  if (totalSeconds < SECONDS_PER_HOUR) return `${Math.floor(totalSeconds / SECONDS_PER_MINUTE)}m`;
  const joinWithRemainder = (major: string, remainder: number, unit: string) =>
    remainder === 0 ? major : `${major} ${remainder}${unit}`;
  if (totalSeconds < SECONDS_PER_DAY) {
    const minutes = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
    return joinWithRemainder(`${Math.floor(totalSeconds / SECONDS_PER_HOUR)}h`, minutes, 'm');
  }
  const hours = Math.floor((totalSeconds % SECONDS_PER_DAY) / SECONDS_PER_HOUR);
  return joinWithRemainder(`${Math.floor(totalSeconds / SECONDS_PER_DAY)}d`, hours, 'h');
};
